const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

const finiteCost = value => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
};

const validDate = value => typeof value === 'string' && DATE_ONLY.test(value);

const groupCostsByDate = events => events.reduce((grouped, event) => {
  grouped.set(event.date, (grouped.get(event.date) || 0) + event.value);
  return grouped;
}, new Map());

export const buildProjectCostCurve = (tasks = []) => {
  const plannedEvents = [];
  const actualEvents = [];
  let plannedWithoutDate = 0;
  let actualWithoutDate = 0;

  tasks.forEach(task => {
    const planned = finiteCost(task?.planned_cost);
    if (planned !== null) {
      if (validDate(task?.due_date)) plannedEvents.push({ date: task.due_date, value: planned });
      else plannedWithoutDate += 1;
    }

    const actual = finiteCost(task?.actual_cost);
    if (actual !== null) {
      if (validDate(task?.completed_date)) actualEvents.push({ date: task.completed_date, value: actual });
      else actualWithoutDate += 1;
    }
  });

  const plannedByDate = groupCostsByDate(plannedEvents);
  const actualByDate = groupCostsByDate(actualEvents);
  const dates = [...new Set([...plannedByDate.keys(), ...actualByDate.keys()])].sort();
  let plannedTotal = 0;
  let actualTotal = 0;
  let plannedStarted = false;
  let actualStarted = false;

  const points = dates.map(date => {
    if (plannedByDate.has(date)) {
      plannedStarted = true;
      plannedTotal += plannedByDate.get(date);
    }
    if (actualByDate.has(date)) {
      actualStarted = true;
      actualTotal += actualByDate.get(date);
    }
    return {
      date,
      planned: plannedStarted ? plannedTotal : null,
      actual: actualStarted ? actualTotal : null,
    };
  });

  return {
    points,
    plannedWithoutDate,
    actualWithoutDate,
    plannedEventCount: plannedEvents.length,
    actualEventCount: actualEvents.length,
    plannedTotal,
    actualTotal,
  };
};
